import { useTranslation } from "react-i18next";

const agenda = [
  { key: "seminars.agenda.topic1", icon: "ri-map-pin-2-line" },
  { key: "seminars.agenda.topic2", icon: "ri-calculator-line" },
  { key: "seminars.agenda.topic3", icon: "ri-palette-line" },
  { key: "seminars.agenda.topic4", icon: "ri-stack-line" },
  { key: "seminars.agenda.topic5", icon: "ri-building-2-line" },
  { key: "seminars.agenda.topic6", icon: "ri-shield-check-line" },
];

export default function AgendaSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-white">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">{t("seminars.agenda.label")}</span>
          <h2 className="mb-4">{t("seminars.agenda.title")}</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {agenda.map((item, idx) => (
            <div
              key={item.key}
              className="group bg-cream rounded-xl p-6 md:p-7 border border-warm-gray/60 transition-all duration-300 hover:bg-graphite hover:border-graphite hover:translate-y-[-4px]"
            >
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-champagne/10 group-hover:bg-champagne/20 shrink-0">
                  <i className={`${item.icon} text-lg text-champagne`} />
                </span>
                <div>
                  <h3 className="text-[1.25rem] md:text-[1.375rem] group-hover:text-white transition-colors duration-300 mb-2">
                    {t(`${item.key}.title`)}
                  </h3>
                  <p className="text-medium-gray text-base group-hover:text-cream/70 transition-colors duration-300 mb-0">
                    {t(`${item.key}.desc`)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}